import React, { useEffect, useState } from 'react'
import { Box, QRCode, Box as Wrapper } from '@node-space/ui-components'

export type ChannelsQRCodeProps = {
  displayAddress: string
  selectedCurrencyCode: string
  protocol: string
  isLoading?: boolean
  isMultiProtocolCurrency: boolean
}

export const ChannelsQRCode = ({
  displayAddress,
  selectedCurrencyCode,
  protocol,
  isLoading = false,
  isMultiProtocolCurrency,
}: ChannelsQRCodeProps) => {
  let currencyIcon

  if ((selectedCurrencyCode === protocol && !isMultiProtocolCurrency) || !protocol) {
    currencyIcon = `${selectedCurrencyCode}`
  } else {
    currencyIcon = `${selectedCurrencyCode}-${protocol}`
  }

  const [isMounted, setMount] = useState(false)

  useEffect(() => {
    setMount(true)
  }, [])

  return (
    <>
      {isLoading || !isMounted ? (
        <Wrapper className="animate-pulse">
          <Box className="h-28 w-32 bg-gray-04 sm:h-32" />
        </Wrapper>
      ) : (
        <QRCode
          value={displayAddress}
          imageUrl={`${process.env.ICONS_URL}${currencyIcon}-border.svg`}
        />
      )}
    </>
  )
}
